import type { ObjectValues } from "../types/object-values";
import packageInfo from "../../package.json";

export const AppConfig = {
  APP_NAME: "PitchForge",
  APP_DESCRIPTION: "PitchForge is a single-page, AI-native web application that empowers individuals and teams to craft, refine, and collaborate on persuasive sales pitches in real time. With a streamlined dual-pane interface, users enter key product details on the left and view instantly generated pitch previews on the right. All pitches are securely stored and shareable within team workspaces for seamless collaboration.",
  APP_TAGLINE: "Forge Persuasive Pitches Instantly",
  PRODUCTION: process.env.NODE_ENV === "production",
  APP_URL: process.env.APP_URL,
  APP_ID: process.env.APP_ID,
  VERSION: packageInfo.version,
  APP_LOGO_URL: "/assets/branding/logo.svg",
} as const;

export type AppConfig = ObjectValues<typeof AppConfig>;
